<template>
  <layout-main-inner title="需求管理">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" />
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="handleCurrentChange(1)"
        >查询</el-button>
        <!-- <el-input
          v-model="config.labName"
          clearable
          placeholder="请输入实验室名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input> -->
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="企业名称"
          prop="vendorName">
        </el-table-column>
        <el-table-column
          label="企业联系人"
          width="100"
          prop="contactMan"
        ></el-table-column>
        <el-table-column
          label="联系电话"
          width="100"
          prop="contactPhone"
        ></el-table-column>
        <el-table-column
          label="服务产品"
          width="100"
          prop="serviceName">
        </el-table-column>
        <el-table-column
          label="行业"
          prop="className"
        ></el-table-column>
        <el-table-column
          label="需求内容"
          min-width="130"
          prop="needDetail"
        ></el-table-column>
        <el-table-column
          label="受理人员"
          prop="acceptStaffName"
        ></el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="检测机构"
          min-width="100"
          prop="acceptSgsName"></el-table-column>
        <el-table-column
          label="状态"
          width="80">
          <template slot-scope="{ row }">
            {{ row.status | needStatus() }}
            <el-tooltip
              v-if="row.status === 9"
              effect="dark"
              :content="row.acceptInfo">
              <i
                style="color:red;"
                class="el-icon-warning"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-if="permission.LVL2 && (assign || accept)"
          label="操作"
          width="100">
          <template slot-scope="{ row }">
            <!-- <el-button
              v-if="assign && (row.status === 0 || row.status === 2)"
              style="margin-right: 10px"
              type="info"
              @click="assignitem(row)">
              分配
            </el-button> -->
            <el-dropdown v-if="row.status !== 9">
              <el-button
                type="primary">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="assign && (row.status === 0 || row.status === 2)"
                  @click.native="assignitem(row)">分配</el-dropdown-item>
                <el-dropdown-item
                  v-if="(row.status === 0 || row.status === 2)"
                  @click.native="acceptinspectionneed(row)">不受理</el-dropdown-item>
                <el-dropdown-item
                  v-if="accept && (row.status === 2 || row.status === 3)"
                  @click.native="createitem(row)">创建受理单</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <user-select-modal
      ref="select"
      :callback="
        () => {
          getlist();
        }
      " />
    <edit-acceptance-modal
      ref="acceptance"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </layout-main-inner>
</template>
<script>

import { mapState } from 'vuex'
import UserSelectModal from './user-select-modal.vue'
import EditAcceptanceModal from '../acceptance/edit-acceptance-modal.vue'
import EntAutoSelect from '../../components/ent-auto-select.vue'
export default {
  name: 'RequirementsIndex',
  components: { UserSelectModal, EditAcceptanceModal, EntAutoSelect },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      menuData: (state) => state.account.menu,
      permission: (state) => state.account.permission
    }),
    accept() {
      const func = this.menuData.find(o => o.menuId === 1058) || {}
      const item = (func.children || []).find(o => o.funcId === 135) || {}
      return (item.operations || []).findIndex(i => i.operation === 'accept') > -1
    },
    assign() {
      const func = this.menuData.find(o => o.menuId === 1058) || {}
      const item = (func.children || []).find(o => o.funcId === 135) || {}
      return (item.operations || []).findIndex(i => i.operation === 'assign') > -1
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    assignitem(row) {
      this.$refs.select.fetch(row)
    },
    createitem(row) {
      console.log(row)
      this.$refs.acceptance.add({
        inspectionNeedId: row.inspectionNeedId,
        vendorId: row.vendorId,
        vendorName: row.vendorName,
        serviceId: row.serviceId,
        classId: [row.classId]
      })
    },
    acceptinspectionneed(row) {
      this.$prompt('请输入不受理原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '请输入不受理原因'
      }).then(({ value }) => {
        this.loading = true
        this.$store.dispatch('account/notacceptinspectionneed', {
          payload: {
            inspectionNeedId: row.inspectionNeedId,
            acceptInfo: value
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
      // this.$confirm('您确定不受理该需求?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.loading = true
      //   this.$store.dispatch('account/acceptinspectionneed', {
      //     payload: {
      //       inspectionNeedId: row.inspectionNeedId
      //     },
      //     success: () => {
      //       this.loading = false
      //       this.getlist()
      //     },
      //     fail: () => {
      //       this.loading = false
      //     }
      //   })
      // })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getinspectionneeds', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
